const getConstantKeyFromStore = (state, key) => {
  let constants = state.constants
  let text = constants[key].default
  if (state.currentPlayerLanguage) {
    let language = state.currentPlayerLanguage
    if (constants[key][language]) {
      text = constants[key][language]
    }
  }

  return text
}

export default {
  getConstantKeyFromStore: getConstantKeyFromStore
}



// WEBPACK FOOTER //
// ./client/lib/utils.js